import { makeStyles, tokens } from "@fluentui/react-components";
/**
 * Styles for ContextualMenu component
 */ export const useStyles = makeStyles({
    root: {
        maxWidth: "none",
        borderRadius: tokens.borderRadiusXLarge
    },
    menuList: {
        maxHeight: "40vh"
    },
    menuItem: {
        maxWidth: "none",
        flexShrink: 0
    },
    menuItemNoHover: {
        maxWidth: "none",
        flexShrink: 0,
        ":hover": {
            backgroundColor: "transparent"
        },
        ":active": {
            backgroundColor: "transparent !important"
        }
    },
    menuDivider: {
        marginRight: "0px",
        marginLeft: "0px"
    },
    searchContainer: {
        paddingLeft: tokens.spacingHorizontalM,
        position: "sticky",
        top: "0",
        zIndex: 1
    }
});
